/*! ORGANO live air-quality board, embeddable widget. v1, 2026-09-06.
 * Free for schools, clinics, community pages, employers and news sites.
 * Data: World Air Quality Index Project station values for 13 locations in Malaysia and
 * Singapore, re-read every 15 minutes by ORGANO and served read-only through Shopify's
 * Storefront API. Live, unvalidated readings; validated data comes from DOE (Malaysia)
 * and NEA (Singapore). The widget keeps a small credit line linking to the tracker page.
 * Band names are the regulators' own words (mirrors the theme's snippets/air-band.liquid):
 *   Malaysia API:  0-50 Good | 51-100 Moderate | 101-200 Unhealthy | 201-300 Very Unhealthy | >300 Hazardous | >500 Emergency
 *   Singapore PSI: 0-50 Good | 51-100 Moderate | 101-200 Unhealthy | 201-300 Very Unhealthy | >300 Hazardous (open ended)
 * Usage:  <div id="organo-haze-widget"></div>
 *         <script async src="https://myorgano.shop/cdn/shop/files/haze-widget.js" data-lang="en"></script>
 * Optional: data-target="<element id>"  data-lang="en|ms|zh"  data-cities="my_kuala_lumpur,sg_central"
 */
(function () {
  'use strict';
  var ENDPOINT = 'https://myorgano.shop/api/2026-07/graphql.json';
  var TOKEN = '3962158613d3e1e1c77b14e4795108a9';
  var PAGE = 'https://myorgano.shop/pages/haze-tracker?utm_source=haze_widget&utm_medium=embed&utm_campaign=haze_tracker_widget';
  var QUERY = '{ shop { metafield(namespace: "organo", key: "air_readings") { value updatedAt } } }';
  var REFRESH_MS = 15 * 60 * 1000;

  var script = document.currentScript || (function () { var s = document.getElementsByTagName('script'); return s[s.length - 1]; })();
  var lang = ((script && script.getAttribute('data-lang')) || 'en').toLowerCase();
  if (lang !== 'ms' && lang !== 'zh') lang = 'en';
  var wanted = (script && script.getAttribute('data-cities')) ? script.getAttribute('data-cities').split(',').map(function (s) { return s.trim(); }) : null;

  var CITIES = [
    ['my_kuala_lumpur', 'Kuala Lumpur', 'Kuala Lumpur', '吉隆坡'],
    ['my_petaling_jaya', 'Petaling Jaya', 'Petaling Jaya', '八打灵再也'],
    ['my_shah_alam', 'Shah Alam', 'Shah Alam', '莎阿南'],
    ['my_ipoh', 'Ipoh', 'Ipoh', '怡保'],
    ['my_penang', 'Penang', 'Pulau Pinang', '槟城'],
    ['my_johor_bahru', 'Johor Bahru', 'Johor Bahru', '新山'],
    ['my_kuching', 'Kuching', 'Kuching', '古晋'],
    ['my_kota_kinabalu', 'Kota Kinabalu', 'Kota Kinabalu', '亚庇'],
    ['sg_central', 'Singapore Central', 'Singapura Tengah', '新加坡中部'],
    ['sg_north', 'Singapore North', 'Singapura Utara', '新加坡北部'],
    ['sg_south', 'Singapore South', 'Singapura Selatan', '新加坡南部'],
    ['sg_east', 'Singapore East', 'Singapura Timur', '新加坡东部'],
    ['sg_west', 'Singapore West', 'Singapura Barat', '新加坡西部']
  ];
  var T = {
    en: { title: 'Live air quality, Malaysia and Singapore', my: 'Malaysia (US AQI)', sg: 'Singapore (US AQI)', updated: 'Updated', source: 'Source: World Air Quality Index Project. Live, unvalidated readings.', credit: 'Live board by ORGANO', unavailable: 'Readings are temporarily unavailable.', ago: 'min ago' },
    ms: { title: 'Kualiti udara langsung, Malaysia dan Singapura', my: 'Malaysia (AQI AS)', sg: 'Singapura (AQI AS)', updated: 'Dikemas kini', source: 'Sumber: World Air Quality Index Project. Bacaan langsung, belum disahkan.', credit: 'Papan langsung oleh ORGANO', unavailable: 'Bacaan tidak tersedia buat masa ini.', ago: 'minit lalu' },
    zh: { title: '马来西亚与新加坡实时空气质量', my: '马来西亚（美国标准 AQI）', sg: '新加坡（美国标准 AQI）', updated: '更新于', source: '数据来源：World Air Quality Index Project。实时读数，未经核实。', credit: '实时看板由 ORGANO 提供', unavailable: '读数暂时无法获取。', ago: '分钟前' }
  }[lang];

  function band(value, market) {
    if (value <= 50) return ['Good', 'good'];
    if (value <= 100) return ['Moderate', 'good'];
    if (value <= 200) return ['Unhealthy', 'warn'];
    if (value <= 300) return ['Very Unhealthy', 'bad'];
    if (market === 'my' && value > 500) return ['Emergency', 'bad'];
    return ['Hazardous', 'bad'];
  }

  var host = document.getElementById((script && script.getAttribute('data-target')) || 'organo-haze-widget');
  if (!host) { host = document.createElement('div'); if (script && script.parentNode) script.parentNode.insertBefore(host, script.nextSibling); else document.body.appendChild(host); }
  host.className = (host.className ? host.className + ' ' : '') + 'ohw';

  if (!document.getElementById('ohw-style')) {
    var st = document.createElement('style'); st.id = 'ohw-style';
    st.textContent = '.ohw{font:14px/1.45 -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;color:#1f2a1c;background:#fdfaf4;border:1px solid #e2dccd;border-radius:14px;padding:16px 18px;max-width:560px;box-sizing:border-box}' +
      '.ohw *{box-sizing:border-box}.ohw-title{font-weight:700;font-size:15px;margin:0 0 10px}.ohw-group{margin:8px 0 0}.ohw-group h4{font-size:12px;letter-spacing:.06em;text-transform:uppercase;color:#6b7266;margin:8px 0 4px;font-weight:600}' +
      '.ohw-row{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:5px 0;border-bottom:1px solid rgba(0,0,0,.05)}.ohw-row:last-child{border-bottom:0}.ohw-city{flex:1}.ohw-val{font-weight:700;font-variant-numeric:tabular-nums;min-width:34px;text-align:right}' +
      '.ohw-band{font-size:12px;padding:2px 8px;border-radius:999px;color:#fff;min-width:96px;text-align:center}.ohw-good{background:#2d5016}.ohw-warn{background:#b08d2e}.ohw-bad{background:#a63d2a}' +
      '.ohw-meta{margin:12px 0 0;font-size:12px;color:#6b7266;line-height:1.5}.ohw-meta a{color:#2d5016;font-weight:600;text-decoration:underline}';
    document.head.appendChild(st);
  }

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function render(data) {
    var readings = data.readings, updated = data.updated;
    var rows = { my: [], sg: [] };
    CITIES.forEach(function (c) {
      var key = c[0];
      if (wanted && wanted.indexOf(key) === -1) return;
      var v = readings[key];
      if (typeof v !== 'number') return;
      var market = key.slice(0, 2), b = band(v, market);
      var name = lang === 'ms' ? c[2] : lang === 'zh' ? c[3] : c[1];
      rows[market].push('<div class="ohw-row"><span class="ohw-city">' + esc(name) + '</span><span class="ohw-val">' + v + '</span><span class="ohw-band ohw-' + b[1] + '">' + b[0] + '</span></div>');
    });
    var age = updated ? Math.max(1, Math.round((Date.now() - updated.getTime()) / 60000)) : null;
    var html = '<p class="ohw-title">' + esc(T.title) + '</p>';
    if (rows.my.length) html += '<div class="ohw-group"><h4>' + esc(T.my) + '</h4>' + rows.my.join('') + '</div>';
    if (rows.sg.length) html += '<div class="ohw-group"><h4>' + esc(T.sg) + '</h4>' + rows.sg.join('') + '</div>';
    if (!rows.my.length && !rows.sg.length) html += '<p>' + esc(T.unavailable) + '</p>';
    html += '<p class="ohw-meta">' + (age ? esc(T.updated) + ' ' + age + ' ' + esc(T.ago) + '. ' : '') + esc(T.source) + ' <a href="' + PAGE + '" target="_blank" rel="noopener">' + esc(T.credit) + '</a></p>';
    host.innerHTML = html;
  }

  function load() {
    var req = new XMLHttpRequest();
    req.open('POST', ENDPOINT, true);
    req.setRequestHeader('Content-Type', 'application/json');
    req.setRequestHeader('X-Shopify-Storefront-Access-Token', TOKEN);
    req.onreadystatechange = function () {
      if (req.readyState !== 4) return;
      try {
        var body = JSON.parse(req.responseText);
        var mf = body.data.shop.metafield;
        var readings = JSON.parse(mf.value);
        var updated = readings.last_updated_iso ? new Date(readings.last_updated_iso) : (mf.updatedAt ? new Date(mf.updatedAt) : null);
        render({ readings: readings, updated: updated });
      } catch (e) {
        host.innerHTML = '<p class="ohw-title">' + esc(T.title) + '</p><p>' + esc(T.unavailable) + '</p><p class="ohw-meta"><a href="' + PAGE + '" target="_blank" rel="noopener">' + esc(T.credit) + '</a></p>';
      }
    };
    req.send(JSON.stringify({ query: QUERY }));
  }
  load();
  setInterval(load, REFRESH_MS);
})();
